import { Handle, Position } from 'reactflow';
import { getLocalizedValue } from '../shared/utils.js';

type StepNodeData = {
  title?: unknown;
  stepType?: unknown;
  status?: 'ok' | 'isolated' | 'missing-input';
};

export function StepNode({ data }: { data: StepNodeData }) {
  const title =
    (getLocalizedValue(data?.title) as string | undefined) ?? 'Untitled Step';
  const stepType =
    (getLocalizedValue(data?.stepType) as string | undefined) ?? 'Unknown';

  const stepTypeClasses: Record<string, string> = {
    'Question: SingleChoice': 'bg-sky-100 text-sky-700 ring-sky-200',
    'Question: MultipleChoice': 'bg-violet-100 text-violet-700 ring-violet-200',
    'Screen: Loading': 'bg-green-100 text-green-700 ring-green-200',
    'Screen: Intro': 'bg-emerald-100 text-emerald-700 ring-emerald-200',
    'Screen: EligibilityCheck': 'bg-lime-100 text-lime-700 ring-lime-200',
    'Info: NextSteps': 'bg-yellow-100 text-yellow-700 ring-yellow-200',
    'Input: FullName': 'bg-indigo-100 text-indigo-700 ring-indigo-200',
    'Input: Age': 'bg-teal-100 text-teal-700 ring-teal-200',
    'Input: PhoneNumber': 'bg-cyan-100 text-cyan-700 ring-cyan-200',
    'Input: EmailAddress': 'bg-blue-100 text-blue-700 ring-blue-200',
    'Input: PostalCode': 'bg-purple-100 text-purple-700 ring-purple-200',
    'Widget: Preferred Store': 'bg-amber-100 text-amber-700 ring-amber-200',
    'Widget: CallbackDatetime':
      'bg-fuchsia-100 text-fuchsia-700 ring-fuchsia-200',
    'Widget: AppointmentDatetime': 'bg-olive-100 text-olive-700 ring-olive-200',
  };
  const stepTypeClass =
    stepTypeClasses[stepType] ?? 'bg-slate-100 text-slate-700 ring-slate-200';

  const classNameByStatus = {
    ok: 'rounded-xl border border-slate-200 bg-white shadow-sm',
    isolated: 'rounded-xl border-2 border-red-600 bg-red-200 shadow-md',
    'missing-input': 'rounded-xl border-2 border-red-500 bg-red-100 shadow-md',
  };
  const statusClass = classNameByStatus[data.status || 'ok'];

  return (
    <div className={`w-80 rounded-2xl border shadow-sm ${statusClass}`}>
      <div className="px-4 py-3">
        <div className="text-sm font-semibold break-words overflow-wrap-anywhere text-slate-900">
          {title}
        </div>
        <div className="mt-2 flex items-center gap-2">
          <span
            className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${stepTypeClass}`}
          >
            {stepType}
          </span>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Left}
        className="h-2.5 w-2.5 !border-2 !border-white !bg-sky-500"
      />
      <Handle
        type="source"
        position={Position.Right}
        className="h-2.5 w-2.5 !border-2 !border-white !bg-sky-500"
      />
    </div>
  );
}
